import * as Yup from 'yup'

import { i18n } from '../i18next'

// Country Code + Phone Number +12282282288

export default Yup.string()
  .min(12, i18n.t('signUp.form.phoneNumber.error'))
  .max(12, i18n.t('signUp.form.phoneNumber.error'))
